import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import NavItem from './NavItem';
import './SideBar.css';

function SideBar(props) {
  const userSession = useSelector((state) => state.core.session.userSession);

  const items = userSession.menu;
  const itemsMenu = userSession.menu_permission;

  const [previousMenusOpen, setPreviousMenusOpen] = useState([]);

  useEffect(() => {
    const pathname = window.location.pathname;

    const findOpenItems = (items, path) => {
      for (let item of items) {
        if (item.path === path) return [item._id];
        if (item.children) {
          const childOpenItems = findOpenItems(item.children, path);
          if (childOpenItems.length) return [item._id, ...childOpenItems];
        }
      }
      return [];
    };

    setPreviousMenusOpen(findOpenItems(items, pathname));
  }, [items]);

  const changeShowLogo = () => {
    if (props.sidebarInfo.classList.contains("sidebar-collapse")) {
      props.setShowLogo(prev => !prev);
    }
  }

  const side_bar = useMemo(() => {
    return (
      <div className="sidebar" onMouseEnter={changeShowLogo} onMouseLeave={changeShowLogo}>
        {/*<!-- Sidebar Menu -->*/}
        <nav className="mt-2">
          {!props.showLogo && (
            <ul className="side-bar-instance-name">
              {userSession.user.instance_name}
            </ul>
          )}

          <ul key="menu" className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {items ? items.map((item) => {
              const menuItem = itemsMenu?.find((menuItem) => menuItem._id === item._id);

              return item.canViewMenu && (
                <NavItem key={item.path} item={item} menuItem={menuItem} previousMenusOpen={previousMenusOpen} />
              );
            }) : ""}
          </ul>
        </nav>
        {/*<!-- /.sidebar-menu -->*/}
      </div>
    );
  }, [props.showLogo]);

  return (
    <>
      {side_bar}
    </>
  );
}
export default SideBar;
